import React from 'react';

import './styles.scss';
import './skeletons/styles.scss';

function BrushSpinner() {
  return (
    <svg
      className="page-loading-spinner"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M62 14 C72 28, 74 48, 58 64 C42 76, 20 72, 12 52"
        stroke="currentColor"
        strokeWidth="7"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function PageLoading({ message = 'Fetching your data.' }) {
  return (
    <div className="page-loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <BrushSpinner />
      <p className="page-loading-title">LOADING...</p>
      <p className="page-loading-message">{message}</p>
    </div>
  );
}
